<div class="card-container">
    <div class="card-component">
        <kendo-tilelayout [columns]="6" [rowHeight]="200" [resizable]="true" [reorderable]="true">

            <kendo-tilelayout-item [title]="customMsgService.translate('visaoGeral')" [col]="1" [colSpan]="2">
                <kendo-tilelayout-item-body>
                    <!-- <h3>{{customMsgService.translate('sites')}}: {{ data.numeroLocais }}</h3> -->
                    <h3>{{customMsgService.translate('armarios')}}: {{ data.numeroArmarios }}</h3>
                    <h3>{{customMsgService.translate('teams')}}: {{ data.numeroEquipas }}</h3>
                    <h3> {{customMsgService.translate('users')}}: {{ data.numeroUtilizadores }}</h3>
                </kendo-tilelayout-item-body>
            </kendo-tilelayout-item>

            
            <kendo-tilelayout-item [title]="customMsgService.translate('numerocasifosOcupados')" [col]="3" [colSpan]="2">
                <kendo-tilelayout-item-body >
                    <span>
                        <span>
                            <div *ngFor="let armario of data.dadosArmarios"> 
                                <h3>   {{ armario.nomeArmario}}: {{armario.numeroCacifosOcupados }} </h3>
                            </div>
                        </span>
                    </span>
                </kendo-tilelayout-item-body>
            </kendo-tilelayout-item>

            <kendo-tilelayout-item [title]="customMsgService.translate('reservasExpiradas')" [col]="5" [colSpan]="2">
                <kendo-tilelayout-item-body >
                    <span>
                      <h3>  <div *ngFor="let armario of data.dadosArmarios"> {{ armario.nomeArmario}}: {{armario.numeroReservasExpiradas}} 
                        </div> </h3> 
                    </span>
                </kendo-tilelayout-item-body>
            </kendo-tilelayout-item>

            <kendo-tilelayout-item [title]="customMsgService.translate('taxaDeOcupacao')" [col]="1"  [colSpan]="6" [rowSpan]="2">
                <kendo-tilelayout-item-body>
                    <kendo-chart [chartArea]="{ margin: { top: 20, bottom: 60, left: 20, right: 20 } }">
                        <kendo-chart-value-axis>
                            <kendo-chart-value-axis-item
                                [labels]="{ format: '{0}%' }">
                            </kendo-chart-value-axis-item>
                          </kendo-chart-value-axis>
                        
                          <kendo-chart-series>
                            <kendo-chart-series-item
                                type="column"
                                [data]="data.dadosArmarios"
                                field="ocupacao"
                                categoryField="nomeArmario"
                                [labels]="{ visible: true, format: '{0}%' }">
                            </kendo-chart-series-item>
                          </kendo-chart-series>
                        </kendo-chart>
                </kendo-tilelayout-item-body>
            </kendo-tilelayout-item>
            


    </kendo-tilelayout>
    </div>
</div>